import { ApiV2 } from '../../commonv2/api/ApiV2';
import { locatePath } from '../../common/RelativeUrl';
import { EventDetails, EventId } from '../types/event';
import { UserInfo } from '../containers/common/userInfo/states/UserFormState';

export const EventApis = {
  base() {
    return new ApiV2(locatePath('/api/v2/events'));
  },
  /**
   * Returns the specified event
   * @returns {Promise<CourseDetail>}
   */
  async find(id: EventId): Promise<EventDetails> {
    return await this.base().withId(id).get();
  },
  /**
   * Find all events held in future
   */
  async findAll(): Promise<EventDetails[]> {
    return await this.base().get();
  },
};

export const EventReservationApis = {
  /**
   * Make a reservation with updating user info
   * If the user is not signed in, it will create a user. If the user is signed in, it'll update the user info
   * @param eventId
   * @param paymentType
   * @param userInfo
   * @param cardToken
   * @param reservationNote
   */
  reserveWithUserForm(
    eventId: EventId,
    paymentType: 'credit_card' | 'token',
    userInfo: UserInfo,
    cardToken: string | null,
    reservationNote?: string
  ) {
    return new ApiV2(locatePath('/api/v2')).appendPath('/events/:eventId/event_reservation').bind({ eventId }).post({
      user: userInfo,
      payment_type: paymentType,
      card_token: cardToken,
      reservation_note: reservationNote,
    });
  },
  /**
   * Make a reservation without updating user info
   * @param eventId
   * @param paymentType
   * @param newCardToken
   * @param reservationNote
   */
  reserve(
    eventId: EventId,
    paymentType: 'credit_card' | 'token',
    newCardToken?: string | null,
    reservationNote?: string
  ) {
    return new ApiV2(locatePath('/api/v2')).appendPath('/events/:eventId/event_reservation').bind({ eventId }).post({
      card_token: newCardToken,
      payment_type: paymentType,
      reservation_note: reservationNote,
    });
  },
};
